import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, domAnimation, LazyMotion, m } from 'motion/react';
import { Image } from '@/app/components/media/image';
import type { RearBodyItem } from '@/app/cv/components/sections/products/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface ProductRearBodyMainSliderProps {
  items: RearBodyItem[];
  currentIndex: number;
  svgSrc?: string;
}
export const ProductRearBodyMainSlider = t0 => {
  const $ = _c(25);
  const {
    items: t1,
    currentIndex: t2,
    svgSrc
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const currentIndex = t2 === undefined ? 0 : t2;
  const activeItem = items[currentIndex];
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "main-slider"
    });
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== activeItem?.title || $[4] !== svgSrc) {
    t5 = !!svgSrc && <div className="pointer-events-none absolute top-0 left-0 z-10 w-full" {...createDataAttributes({
      test: "main-image"
    })}><Image src={svgSrc} alt={activeItem?.title || ""} width={600} height={225} aspectRatio="aspect-8-3" objectFit="contain" objectPosition="top" sizes="(min-width: 1024px) 1200px, 100vw" /></div>;
    $[3] = activeItem?.title;
    $[4] = svgSrc;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = createDataAttributes({
      test: "items-container"
    });
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0
    };
    t8 = {
      opacity: 1
    };
    t9 = {
      opacity: 0
    };
    t10 = {
      duration: 1,
      ease: "easeInOut"
    };
    $[7] = t10;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  const t11 = `item-${currentIndex}`;
  let t12;
  if ($[11] !== t11) {
    t12 = createDataAttributes({
      test: t11,
      active: true
    });
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== activeItem) {
    t13 = !!activeItem?.image && <Image src={activeItem.image.src} alt={activeItem.image.alt || activeItem.title || ""} width={600} height={225} aspectRatio="aspect-8-3" objectFit="contain" objectPosition="top" />;
    $[13] = activeItem;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== activeItem) {
    t14 = !!activeItem?.title && <div className="mt-6 text-center sm:mt-10 lg:mt-20" {...createDataAttributes({
      test: "main-title"
    })}><h3 className="text-h3 font-display text-white" dangerouslySetInnerHTML={{
        __html: activeItem.title
      }} /></div>;
    $[15] = activeItem;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== currentIndex || $[18] !== t12 || $[19] !== t13 || $[20] !== t14) {
    t15 = <div className="grid" {...t6}><LazyMotion features={domAnimation}><AnimatePresence mode="sync"><m.div key={currentIndex} initial={t7} animate={t8} exit={t9} transition={t10} className="col-start-1 row-start-1" {...t12}>{t13}{t14}</m.div></AnimatePresence></LazyMotion></div>;
    $[17] = currentIndex;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t15 || $[23] !== t5) {
    t16 = <div className="relative" {...t4}>{t5}{t15}</div>;
    $[22] = t15;
    $[23] = t5;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  return t16;
};